/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meeting_Attendees_MoreInputs */



/**
* | output |
* | --- |
* | "+{count} others" |
*
* @param {Meeting_Attendees_MoreInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_attendees_more = /** @type {((inputs: Meeting_Attendees_MoreInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Attendees_MoreInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`+${i?.count} anderen`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`+${i?.count} autres`)
	return /** @type {LocalizedString} */ (`+${i?.count} others`)
});